import React, { useEffect, useState } from "react";
import {Tooltip} from "react-tippy";

function InfoTooltip({children}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 991;
            if (mobile !== isMobile) {
                setIsMobile(mobile);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isMobile]);

    return <Tooltip
        html={(
            <div className="tooltip-info__content form-tooltip__content">
                {children}
            </div>
        )}
        animation="fade"
        position="top-start"
        trigger={isMobile ? "click" : "mouseenter"}
        theme="light"
        arrow={true}
        delay={200}
    >
        <div className="tooltip-info">
            <div className="tooltip-info__icon">
                <img src="/_core/assets/themes/v5/assets/img/form3/info-icon.svg" alt="" />
            </div>
        </div>
    </Tooltip>
}

export default InfoTooltip;